import { ChildrenItem } from "../base"
import { emptyLayout } from "./model"
import { home, bs, listPage, appHome, appListPage } from "./diffrence_options"
// import loginIcon from "../../assets/images/leftMenu/login/login1.png"
// import icon from "../../assets/images/homeLeftMenu/base/icon_free_layout.png"
import bs_icon from "../../assets/images/leftMenu/base/cx_layout.png"

let icon = "icon-portal-free_layout"

export let emptylayout_children = []
export let bigScreen_emptylayout_children = []
export let app_emptylayout_children = []
export let listPageDefaultData = new emptyLayout(listPage[0])
export let appListPageDefaultData = new emptyLayout(appListPage[0])
for (let i = 0; i < home.length; i++) {
  emptylayout_children.push(
    new ChildrenItem("自由布局样式" + i, icon, "emptyLayoutComponent", new emptyLayout(home[i]))
  )
}
for (let i = 0; i < bs.length; i++) {
  bigScreen_emptylayout_children.push(
    new ChildrenItem("自由布局样式" + i, bs_icon, "layoutComponentBigScreen", new emptyLayout(bs[i]))
  )
}
for (let i = 0; i < appHome.length; i++) {
  app_emptylayout_children.push(
    new ChildrenItem("自由布局样式" + i, icon, "emptyLayoutComponent", new emptyLayout(appHome[i]))
  )
}
